import './SearchBox.scss';
import { TextField } from '@mui/material';
import { GoabIconButton } from '@abgov/react-components';

export interface SearchBoxProps {
  testId?: string;
  name?: string;
  placeholder: string;
  value: string;
  onChange: (name: string, value: string) => void;
  onSearch: () => void;
  onClose: () => void;
  // optional preview dropdown (e.g. a search-preview-wrap list/table), rendered below the input row
  children?: React.ReactNode;
}

// Shared search input used by both the users list and role search: a bordered box containing
// the text field and search/close icon buttons, so both pages look and behave identically.
export const SearchBox = (props: SearchBoxProps) => {
  const { testId = 'search', name = 'search', placeholder, value, onChange, onSearch, onClose, children } = props;

  function handleKeyEvent(event: any) {
    if (event.code === 'Enter' || event.code === 'NumpadEnter') {
      event.preventDefault();
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
      onSearch();
    }
  }

  return (
    <div className='txt-search-wrap' onKeyDown={handleKeyEvent}>
      <div className='search-input'>
        <TextField type='text' name={name} data-testid={testId}
          placeholder={placeholder}
          autoComplete='off'
          value={value}
          onChange={(e: any) => onChange(e.target.name, e.target.value)}
        />
      </div>
      <div className='search-buttons-wrap'>
        {value.length === 0
          ? <GoabIconButton testId={`${testId}-search-icon`} icon="search" variant="dark" size="medium" disabled title="Search" onClick={onSearch} />
          : <GoabIconButton testId={`${testId}-search-icon`} icon="search" variant="dark" size="medium" title="Search" onClick={onSearch} />
        }
        {value.length === 0
          ? <div style={{ width: '26px' }}></div>
          : <GoabIconButton testId={`${testId}-close-icon`} icon="close" variant="dark" size="medium" title="Close" onClick={onClose} />
        }
      </div>
      {children}
    </div>
  );
};
